export enum OrderStatus {
    Ordered = "Ordered",
    WaitingPickup = "WaitingPickup",
    Cleaning = "Cleaning",
    WaitingReturn = "WaitingReturn",
    Completed = "Completed",
}

export enum ClearingStatus {
    Success = "Success",
    MonthlyInvoice = "MonthlyInvoice"
}

export enum OrderType {
    Cleaning = "Cleaning",
    WelcomePackage = "WelcomePackage"
}

export interface Person {
    salutation: string;
    title: string;
    firstname: string;
    lastname: string;
}

export interface CubeOrder {
    orderId: number;
    orderIdPrint: string;
    orderDate: number;
    orderStatus: OrderStatus;
    orderType: string;
    person: Person;
    email: string;
    accessCode: string;
    clearingStatus?: ClearingStatus;
}

export interface Cleaner {
    accessCode: string;
    requiredWelcomePackages: number;
    cleanerCompany: string;
}

export enum ClesyBoxType {
    SuitBag = "SuitBag",
    WelcomePackage = "WelcomePackage",
    Storage = "Storage",
}

export type OrderStorage = { [orderCode: string]: CubeOrder };
